import { useEffect, useRef, DependencyList } from "react";

export function useDebounceEffect(
  fn: () => void,
  waitTime: number,
  deps: DependencyList = []
) {
  const callback = useRef(fn);
  const isFirstRender = useRef(true);

  useEffect(() => {
    callback.current = fn;
  }, [fn]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    const t = setTimeout(() => {
      callback.current();
    }, waitTime);

    return () => {
      clearTimeout(t);
    };
    // eslint-disable-next-line
  }, [waitTime, ...deps]);
}
